import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

export default function InputWrap ({ size, children }) {
    const wrapClassNames = classNames('input-wrap', {
        'input-wrap--half': size === 'half',
        'input-wrap--two-third': size === 'two-third',
        'input-wrap--third': size === 'third'
    })

    return (
        <div className={wrapClassNames}>
            { children }
        </div>
    )
}

InputWrap.propTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.array, PropTypes.string]),
    size: PropTypes.oneOf(['half', 'third','two-third'])
}